import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

class CostPerServing extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateCostPerServing);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateCostPerServing);
  }

  /**
   * Updates the cost per serving display.
   * @param {CustomEvent} event - The variant update event.
   */
  updateCostPerServing = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newCostPerServing = event.detail.data.html.querySelector('cost-per-serving');

    if (!newCostPerServing) return;

    // Update visibility attribute
    this.dataset.visible = newCostPerServing.dataset.visible;

    // Morph the children
    morph(this, newCostPerServing, { childrenOnly: true });
  };
}

if (!customElements.get('cost-per-serving')) {
  customElements.define('cost-per-serving', CostPerServing);
}
